import styled from '@emotion/styled';

export const FooterContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  borderTop: `1px solid ${theme.colors.gray[3]}`,
  background: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
  padding: theme.spacing.sm,
  flexShrink: 0,
}));

export const FooterPreview = styled('div')(({ theme }) => ({
  borderRadius: theme.radius.sm,
  border: `1px solid ${theme.colors.gray[2]}`,
  padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
  cursor: 'pointer',
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing.xs,
  transition: 'background-color 150ms ease, border-color 150ms ease',
  '&:hover': {
    backgroundColor: theme.colors.gray[0],
    borderColor: theme.colors.gray[3],
  },
}));
